import { errorStyle } from "../../../constants/styles";
var obj = require("lodash/object");

const FormFieldErrors: React.FC<any> = ({
  errors,
  field,
  requiredMessage = "This field is required to continue",
  matchMessage = `The field is invalid`,
}) => {
  return (
    <>
      {obj.get(errors, field, false) && (
        <>
          {obj.get(errors, field).type === "required" && (
            <span className={errorStyle}>{requiredMessage}</span>
          )}
          {obj.get(errors, field).type === "pattern" && (
            <span className={errorStyle}>{matchMessage}</span>
          )}
          {obj.get(errors, field).type === "api" && (
            <span className={errorStyle}>{obj.get(errors, field).message}</span>
          )}
        </>
      )}
    </>
  );
};

export default FormFieldErrors;
